import { computed } from 'vue';

import { useAuthStore } from '@/stores/auth';

/**
 * Composable that provides a simplified interface to the auth store
 * @returns Auth-related state and functions
 */
export function useAuth() {
  const authStore = useAuthStore();

  // Computed properties
  const isAuthenticated = computed(() => authStore.isLogin);
  const user = computed(() => authStore.user);
  const memberships = computed(() => authStore.memberships || []);
  const loading = computed(() => authStore.loading);
  const currentOrgId = computed(() => authStore.lastVisitedOrgId);

  // Methods
  const login = async (tokens: { idToken: string; accessToken: string; refreshToken: string }) => {
    authStore.setTokens(tokens);
    await authStore.loadUserFromToken(); // This already calls fetchUserMemberships
  };

  const logout = () => {
    authStore.logout();
  };

  const loadUser = async () => {
    await authStore.loadUserFromToken(); // This already calls fetchUserMemberships
  };

  const setCurrentOrg = (orgId: string) => {
    authStore.setLastVisitedOrgId(orgId);
  };

  return {
    isAuthenticated,
    user,
    memberships,
    loading,
    currentOrgId,
    login,
    logout,
    loadUser,
    setCurrentOrg,
  };
}
